
import {
    GrpcService,
    HttpRequestDelegate,
} from "../../grpc"

import {
    DoubleValue,
} from "../../google/protobuf/wrappers"

export interface GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest {
    name: string
}

export interface GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse {
    accountIds: Array<number>
}

export interface GetAllInsoleCustomDataRequest {
}

export interface GetAllInsoleCustomDataResponse {
    insoleCustomData: Array<InsoleCustomData>
}

export interface GetAccountsInsoleCustomDataRequest {
    accountIds: Array<number>
}

export interface GetAccountsInsoleCustomDataResponse {
    insoleCustomData: Array<InsoleCustomDataListForAccounts>
}

export interface UpdateInsoleCustomShippingRequest {
    insoleCustomDataId: number
    shippingStatus: ShippingStatus
}

export interface UpdateInsoleCustomShippingResponse {
    done: boolean
}

export interface GetInsoleCustomDataListRequest {
}

export interface GetInsoleCustomDataListResponse {
    insoleCustomData: Array<InsoleCustomData>
}

export interface CreateOrUpdateInsoleCustomDataRequest {
    insoleCustomData: InsoleCustomData
}

export interface CreateOrUpdateInsoleCustomDataResponse {
    insoleCustomDataId: number
}

export interface InsoleCustomData {
    name: string
    age: string
    shoeSize: number
    height: string
    weight: string
    backAndFloatMedia?: string
    squatMedia?: string
    footBackViewData?: string
    footVerticalViewMedia?: string
    archFigureMediaLeft?: string
    archFigureMediaRight?: string
    footFigureMedia?: string
    footLengthRight?: string
    orderStatus: OrderStatus
    insoleCustomDataId?: number
    footWidthRight?: string
    footHeightRight?: string
    shippingStatus: ShippingStatus
    accountId?: number
    footLengthLeft?: string
    footWidthLeft?: string
    footHeightLeft?: string
    createTimestamp: number
}

export interface GetAllPersonaRequest {
    accountIds: Array<number>
}

export interface GetAllPersonaResponse {
    allPersona: Array<AllPersona>
}

export interface AllPersona {
    accountId: number
    bodyInfoResult: BodyInfo
    socialResult: SocialInfo
    contactInfoResult: ContactInfo
    workInfoResult: WorkInfo
    intrinsicInfoResult: IntrinsicInfo
}

export interface CreateBodyByAccessTokenRequest {
    bodyInfo: CreateBodyByAccessToken
}

export interface CreateBodyByAccessToken {
    heightScalar?: string
    heightUnit?: string
    weightScalar?: string
    weightUnit?: string
}

export interface CreateBodyByAccessTokenResponse {
    bodyId: number
}

export interface CreateOrUpdateIntrinsicByAccessTokenRequest {
    birthdate?: number
    gender: Gender
}

export interface CreateOrUpdateIntrinsicByAccessTokenResponse {
    isFinished: boolean
}

export interface CreateOrUpdateContactByAccessTokenRequest {
    /*职业 */
    mobileNumber?: string
    /*收入 */
    address?: number
}

export interface CreateOrUpdateContactByAccessTokenResponse {
    isFinished: boolean
}

export interface CreateOrUpdateWorkByAccessTokenRequest {
    /*职业 */
    profession?: string
    /*收入 */
    income: DoubleValue
    resume?: string
}

export interface CreateOrUpdateWorkByAccessTokenResponse {
    isFinished: boolean
}

export interface CreateOrUpdateSocialByAccessTokenRequest {
    /*头像 */
    avatar?: string
    /*真实姓名 */
    realName?: string
    /*显示姓名 */
    displayName?: string
}

export interface CreateOrUpdateSocialByAccessTokenResponse {
    isFinished: boolean
}

export interface GetIntrinsicRequest {
}

export interface GetIntrinsicResponse {
    intrinsicInfoResult: IntrinsicInfo
}

export interface GetWorkRequest {
}

export interface GetWorkResponse {
    workInfoResult: WorkInfo
}

export interface GetContactRequest {
}

export interface GetContactResponse {
    contactInfoResult: ContactInfo
}

export interface GetSocialRequest {
}

export interface GetSocialResponse {
    socialResult: SocialInfo
}

export interface GetBodyRequest {
}

export interface GetBodyResponse {
    bodyInfoResult: BodyInfo
}

export interface SocialInfo {
    /*账号id */
    accountId: number
    /*头像 */
    avatar?: string
    /*真实姓名 */
    realName?: string
    /*显示姓名 */
    displayName?: string
}

export interface CreateSocialRequest {
    socialInfo: SocialInfo
}

export interface CreateSocialResponse {
    /*社会属性id */
    socialId: number
}

export interface UpdateSocialRequest {
    socialInfo: SocialInfo
}

export interface UpdateSocialResponse {
    /*是否修改成功 */
    isUpdated: boolean
}

export interface DeleteSocialRequest {
    /*账号id */
    accountId: number
}

export interface DeleteSocialResponse {
    /*是否修改成功 */
    isDeleted: boolean
}

export interface GetSocialByAccountIdsRequest {
    /*账号id */
    accountIds: Array<number>
}

export interface GetSocialByAccountIdsResponse {
    socialResults: Array<SocialInfo>
}

export interface WorkInfo {
    /*账号id */
    accountId: number
    /*职业 */
    profession?: string
    /*收入 */
    income: DoubleValue
    resume?: string
}

export interface CreateWorkRequest {
    workInfo: WorkInfo
}

export interface CreateWorkResponse {
    /*社会属性id */
    workId: number
}

export interface UpdateWorkRequest {
    workInfo: WorkInfo
}

export interface UpdateWorkResponse {
    /*是否修改成功 */
    isUpdated: boolean
}

export interface GetWorkByAccountIdsRequest {
    /*账号id */
    accountIds: Array<number>
}

export interface GetWorkByAccountIdsResponse {
    workInfoResults: Array<WorkInfo>
}

export interface ContactInfo {
    /*账号id */
    accountId: number
    /*职业 */
    mobileNumber?: string
    /*收入 */
    address?: number
}

export interface CreateContactRequest {
    contactInfo: ContactInfo
}

export interface CreateContactResponse {
    /*联系id */
    contactId: number
}

export interface UpdateContactRequest {
    contactInfo: ContactInfo
}

export interface UpdateContactResponse {
    /*是否修改成功 */
    isUpdated: boolean
}

export interface GetContactByAccountIdsRequest {
    /*账号id */
    accountIds: Array<number>
}

export interface GetContactByAccountIdsResponse {
    contactInfoResults: Array<ContactInfo>
}

export interface BodyInfo {
    /*账号id */
    accountId: number
    heightScalar?: string
    heightUnit?: string
    weightScalar?: string
    weightUnit?: string
}

export interface CreateBodyRequest {
    bodyInfo: BodyInfo
}

export interface CreateBodyResponse {
    /*联系id */
    bodyId: number
}

export interface GetBodyByAccountIdsRequest {
    /*账号id */
    accountIds: Array<number>
}

export interface GetBodyByAccountIdsResponse {
    /*是否修改成功 */
    bodyInfoResults: Array<BodyInfo>
}

export interface IntrinsicInfo {
    /*账号id */
    accountId: number
    birthdate?: number
    gender: Gender
}

export interface CreateIntrinsicRequest {
    intrinsicInfo: IntrinsicInfo
}

export interface CreateIntrinsicResponse {
    /*联系id */
    intrinsicId: number
}

export interface UpdateIntrinsicRequest {
    intrinsicInfo: IntrinsicInfo
}

export interface UpdateIntrinsicResponse {
    /*是否修改成功 */
    isUpdated: boolean
}

export interface GetIntrinsicByAccountIdsRequest {
    /*账号id */
    accountIds: Array<number>
}

export interface GetIntrinsicByAccountIdsResponse {
    /*是否修改成功 */
    intrinsicInfoResults: Array<IntrinsicInfo>
}

export interface CreateOrUpdateIntrinsicRequest {
    intrinsicInfo: IntrinsicInfo
}

export interface CreateOrUpdateIntrinsicResponse {
    /*是否修改成功 */
    isFinished: boolean
}

export interface CreateOrUpdateContactRequest {
    contactInfo: ContactInfo
}

export interface CreateOrUpdateContactResponse {
    /*是否修改成功 */
    isFinished: boolean
}

export interface CreateOrUpdateWorkRequest {
    workInfo: WorkInfo
}

export interface CreateOrUpdateWorkResponse {
    /*是否修改成功 */
    isFinished: boolean
}

export interface CreateOrUpdateSocialRequest {
    socialInfo: SocialInfo
}

export interface CreateOrUpdateSocialResponse {
    /*是否修改成功 */
    isFinished: boolean
}

export interface GetBodyListByAccountIdsRequest {
    /*账号id */
    accountIds: Array<number>
}

export interface GetBodyListByAccountIdsResponse {
    /*是否修改成功 */
    bodyInfoResults: Array<BodyInfo>
}

export interface InsoleCustomDataListForAccounts {
    accountId: number
    insoleCustomData: Array<InsoleCustomData>
}

export enum ShippingStatus {
    NOT_SHIPPING = 0,
    HAS_SHIPPING = 1,
}

export enum OrderStatus {
    HAS_CUSTOM = 0,
    NOT_CUSTOM = 1,
}

export enum Gender {
    MALE = 0,
    FEMALE = 1,
    UNKNOWN = 2,
}

export class PersonaService extends GrpcService {
    constructor(host: string, httpRequestDelegate: HttpRequestDelegate) {
        super(host, httpRequestDelegate)
    }
    
    async createSocial(request: CreateSocialRequest): Promise<CreateSocialResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/CreateSocial"
        return await this.call(method, path, request) as CreateSocialResponse
    }
    
    async updateSocial(request: UpdateSocialRequest): Promise<UpdateSocialResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/UpdateSocial"
        return await this.call(method, path, request) as UpdateSocialResponse
    }
    
    async getSocialByAccountIds(request: GetSocialByAccountIdsRequest): Promise<GetSocialByAccountIdsResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/GetSocialByAccountIds"
        return await this.call(method, path, request) as GetSocialByAccountIdsResponse
    }
    
    async createWork(request: CreateWorkRequest): Promise<CreateWorkResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/CreateWork"
        return await this.call(method, path, request) as CreateWorkResponse
    }
    
    async updateWork(request: UpdateWorkRequest): Promise<UpdateWorkResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/UpdateWork"
        return await this.call(method, path, request) as UpdateWorkResponse
    }
    
    async getWorkByAccountIds(request: GetWorkByAccountIdsRequest): Promise<GetWorkByAccountIdsResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/GetWorkByAccountIds"
        return await this.call(method, path, request) as GetWorkByAccountIdsResponse
    }
    
    async createContact(request: CreateContactRequest): Promise<CreateContactResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/CreateContact"
        return await this.call(method, path, request) as CreateContactResponse
    }
    
    async updateContact(request: UpdateContactRequest): Promise<UpdateContactResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/UpdateContact"
        return await this.call(method, path, request) as UpdateContactResponse
    }
    
    async getContactByAccountIds(request: GetContactByAccountIdsRequest): Promise<GetContactByAccountIdsResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/GetContactByAccountIds"
        return await this.call(method, path, request) as GetContactByAccountIdsResponse
    }
    
    async createBody(request: CreateBodyRequest): Promise<CreateBodyResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/CreateBody"
        return await this.call(method, path, request) as CreateBodyResponse
    }
    
    async getBodyListByAccountIds(request: GetBodyListByAccountIdsRequest): Promise<GetBodyListByAccountIdsResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/GetBodyListByAccountIds"
        return await this.call(method, path, request) as GetBodyListByAccountIdsResponse
    }
    
    async getBodyByAccountIds(request: GetBodyByAccountIdsRequest): Promise<GetBodyByAccountIdsResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/GetBodyByAccountIds"
        return await this.call(method, path, request) as GetBodyByAccountIdsResponse
    }
    
    async createIntrinsic(request: CreateIntrinsicRequest): Promise<CreateIntrinsicResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/CreateIntrinsic"
        return await this.call(method, path, request) as CreateIntrinsicResponse
    }
    
    async updateIntrinsic(request: UpdateIntrinsicRequest): Promise<UpdateIntrinsicResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/UpdateIntrinsic"
        return await this.call(method, path, request) as UpdateIntrinsicResponse
    }
    
    async getIntrinsicByAccountIds(request: GetIntrinsicByAccountIdsRequest): Promise<GetIntrinsicByAccountIdsResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/GetIntrinsicByAccountIds"
        return await this.call(method, path, request) as GetIntrinsicByAccountIdsResponse
    }
    
    async createOrUpdateIntrinsic(request: CreateOrUpdateIntrinsicRequest): Promise<CreateOrUpdateIntrinsicResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/CreateOrUpdateIntrinsic"
        return await this.call(method, path, request) as CreateOrUpdateIntrinsicResponse
    }
    
    async createOrUpdateContact(request: CreateOrUpdateContactRequest): Promise<CreateOrUpdateContactResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/CreateOrUpdateContact"
        return await this.call(method, path, request) as CreateOrUpdateContactResponse
    }
    
    async createOrUpdateWork(request: CreateOrUpdateWorkRequest): Promise<CreateOrUpdateWorkResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/CreateOrUpdateWork"
        return await this.call(method, path, request) as CreateOrUpdateWorkResponse
    }
    
    async createOrUpdateSocial(request: CreateOrUpdateSocialRequest): Promise<CreateOrUpdateSocialResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/CreateOrUpdateSocial"
        return await this.call(method, path, request) as CreateOrUpdateSocialResponse
    }
    
    /*region 个人获取个人信息 */
    async getBody(request: GetBodyRequest): Promise<GetBodyResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/GetBody"
        return await this.call(method, path, request) as GetBodyResponse
    }
    
    async getSocial(request: GetSocialRequest): Promise<GetSocialResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/GetSocial"
        return await this.call(method, path, request) as GetSocialResponse
    }
    
    async getContact(request: GetContactRequest): Promise<GetContactResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/GetContact"
        return await this.call(method, path, request) as GetContactResponse
    }
    
    async getWork(request: GetWorkRequest): Promise<GetWorkResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/GetWork"
        return await this.call(method, path, request) as GetWorkResponse
    }
    
    async getIntrinsic(request: GetIntrinsicRequest): Promise<GetIntrinsicResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/GetIntrinsic"
        return await this.call(method, path, request) as GetIntrinsicResponse
    }
    
    async createOrUpdateIntrinsicByAccessToken(request: CreateOrUpdateIntrinsicByAccessTokenRequest): Promise<CreateOrUpdateIntrinsicByAccessTokenResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/CreateOrUpdateIntrinsicByAccessToken"
        return await this.call(method, path, request) as CreateOrUpdateIntrinsicByAccessTokenResponse
    }
    
    async createOrUpdateContactByAccessToken(request: CreateOrUpdateContactByAccessTokenRequest): Promise<CreateOrUpdateContactByAccessTokenResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/CreateOrUpdateContactByAccessToken"
        return await this.call(method, path, request) as CreateOrUpdateContactByAccessTokenResponse
    }
    
    async createOrUpdateWorkByAccessToken(request: CreateOrUpdateWorkByAccessTokenRequest): Promise<CreateOrUpdateWorkByAccessTokenResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/CreateOrUpdateWorkByAccessToken"
        return await this.call(method, path, request) as CreateOrUpdateWorkByAccessTokenResponse
    }
    
    async createOrUpdateSocialByAccessToken(request: CreateOrUpdateSocialByAccessTokenRequest): Promise<CreateOrUpdateSocialByAccessTokenResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/CreateOrUpdateSocialByAccessToken"
        return await this.call(method, path, request) as CreateOrUpdateSocialByAccessTokenResponse
    }
    
    async createBodyByAccessToken(request: CreateBodyByAccessTokenRequest): Promise<CreateBodyByAccessTokenResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/CreateBodyByAccessToken"
        return await this.call(method, path, request) as CreateBodyByAccessTokenResponse
    }
    
    async getAllPersona(request: GetAllPersonaRequest): Promise<GetAllPersonaResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/GetAllPersona"
        return await this.call(method, path, request) as GetAllPersonaResponse
    }
    
    /* sennofit pro */
    async getInsoleCustomDataList(request: GetInsoleCustomDataListRequest): Promise<GetInsoleCustomDataListResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/GetInsoleCustomDataList"
        return await this.call(method, path, request) as GetInsoleCustomDataListResponse
    }
    
    async createOrUpdateInsoleCustomData(request: CreateOrUpdateInsoleCustomDataRequest): Promise<CreateOrUpdateInsoleCustomDataResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/CreateOrUpdateInsoleCustomData"
        return await this.call(method, path, request) as CreateOrUpdateInsoleCustomDataResponse
    }
    
    async updateInsoleCustomShipping(request: UpdateInsoleCustomShippingRequest): Promise<UpdateInsoleCustomShippingResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/UpdateInsoleCustomShipping"
        return await this.call(method, path, request) as UpdateInsoleCustomShippingResponse
    }
    
    async getAccountsInsoleCustomData(request: GetAccountsInsoleCustomDataRequest): Promise<GetAccountsInsoleCustomDataResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/GetAccountsInsoleCustomData"
        return await this.call(method, path, request) as GetAccountsInsoleCustomDataResponse
    }
    
    async getAllInsoleCustomData(request: GetAllInsoleCustomDataRequest): Promise<GetAllInsoleCustomDataResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/GetAllInsoleCustomData"
        return await this.call(method, path, request) as GetAllInsoleCustomDataResponse
    }
    
    async getSocialAccountIdByRealNameContainsOrDisplayNameContains(request: GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest): Promise<GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse> {
        const method = "post"
        const path = "/base.persona.PersonaService/GetSocialAccountIdByRealNameContainsOrDisplayNameContains"
        return await this.call(method, path, request) as GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse
    }
    
}
